import React, { useState, useRef } from "react";
import UserInfoForm from "../../components/UserBasicForm";
import IntroSection from "../../components/IntroSection";
import styles from './index.module.scss';
import { Button } from "../../common/components/Button";
import Loader from "../../common/components/Loader";
import { UseFormReturn } from "react-hook-form";
import { formatDateToLocalISOString } from "../../utils/commonFunctions";
import { handleNonInfinipathSeekerUpdate } from "../../utils/addNewSeeker";
import { useNavigate } from "react-router-dom";


interface IFormInput {
  firstName: string;
  lastName: string;
  email: string;
  dob: Date;
  city: string;
  otherCity?: string;
  location?: string;
  terms: boolean;
}

const UserBasicPage = () => {
  const [loader, setLoader] = useState(false);
  const [formErrors, setFormErrors] = useState<any>(null);
  const [updateMessage, setUpdateMessage] = useState<string>("");
  const formMethodsRef = useRef<UseFormReturn<IFormInput> | null>(null);
  const navigate = useNavigate();
  // Handle form methods from UserInfoForm
  const handleFormMethodsReady = (methods: UseFormReturn<IFormInput>) => {
    formMethodsRef.current = methods;
  };

  // Update seeker callback function
  const handleUpdateSeeker = (status: boolean, message: string) => {
    setUpdateMessage(message);
    if (status) {
      console.log("Update successful:", message);
      // You can add navigation or other success actions here
      // navigate("/next-page");
    } else {
      console.error("Update failed:", message);
    }
  };

  // Handle form submission
  const handleFormSubmit = (data: IFormInput) => {
    const formattedDob = formatDateToLocalISOString(data.dob);
    const payload = {
      firstName: data.firstName,
      lastName: data.lastName,
      fullName: `${data.firstName} ${data.lastName}`,
      email: data.email,
      address: data.city,
      ...(formattedDob !== null && { dob: formattedDob }),
      ...(data.city === "Other" && { otherAddress: data.otherCity }),
      termsAndConditions: data.terms,
    };
    
    setLoader(true);
    setFormErrors(null);
    setUpdateMessage("");
    
    // Call the API function
    handleNonInfinipathSeekerUpdate(
      payload,
      handleUpdateSeeker,
      setLoader,
      () => {
        navigate("/infinipath/list", { replace: true });
        // window.location.reload();
      }
    );
  };

  // Handle continue button click
  const handleContinueClick = () => {
    if (formMethodsRef.current) {
      // Trigger form validation and submission
      formMethodsRef.current.handleSubmit(
        handleFormSubmit,
        (errors) => {
          // Handle form validation errors
          setFormErrors(errors);
          console.log("Form validation errors:", errors);
        }
      )();
    }
  };

  return (
    <div>
      <div className={styles.backgroundSection}>
        <IntroSection />
        <UserInfoForm 
          onFormSubmit={handleFormSubmit}
          onFormMethodsReady={handleFormMethodsReady}
        />
      </div>
        <div className={styles.buttonContainer}>
        {loader ? (
          <div className={styles.loaderContainer}>
            <Loader type="small" />
          </div>
        ) : (
          <Button onClick={handleContinueClick} >
            <span className={styles.buttonText}>continue</span>
          </Button>
        )}
      </div>
      {updateMessage && (
        <div className={styles.updateMessage}>
          <p>{updateMessage}</p>
        </div>
      )}
    </div>
  );
};

export default UserBasicPage;